import { quadrantsENUM } from './config/quadrants';
import { ringsENUM } from './config/rings';

const lastUpdate = new Date('2022-11-28');

export default [
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Airflow',
    id: 'Airflow',
    title: 'Airflow',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Bitrise',
    id: 'Bitrise',
    title: 'Bitrise',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Cloudwatch-logs',
    id: 'Cloudwatch-logs',
    title: 'Cloudwatch logs',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Databricks-for-spark-jobs',
    id: 'Databricks-for-spark-jobs',
    title: 'Databricks for spark jobs',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Datadog',
    id: 'Datadog',
    title: 'Datadog',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Docker-CLI',
    id: 'Docker-CLI',
    title: 'Docker CLI',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Docker-desktop',
    id: 'Docker-desktop',
    title: 'Docker desktop',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Firebase-monitoring-analytics-mobile',
    id: 'Firebase-monitoring-analytics-mobile',
    title: 'Firebase monitoring + analytics mobile',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Github',
    id: 'Github',
    title: 'Github',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Google-maps',
    id: 'Google-maps',
    title: 'Google maps',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Graphhopper',
    id: 'Graphhopper',
    title: 'Graphhopper',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Api-docs-OPEN-API',
    id: 'Api-docs-OPEN-API',
    title: 'Api docs - OPEN API',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.TRIAL,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Algolia-for-full-text-search',
    id: 'Algolia-for-full-text-search',
    title: 'Algolia for full text search',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Backstage',
    id: 'Backstage',
    title: 'Backstage',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.HOLD,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Ansible',
    id: 'Ansible',
    title: 'Ansible',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Scylla-nosql-timeseries',
    id: 'Scylla-nosql-timeseries',
    title: 'Scylla nosql timeseries',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Kafka-connect',
    id: 'Kafka-connect',
    title: 'Kafka connect',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ASSESS,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Datadog-logs',
    id: 'Datadog-logs',
    title: 'Datadog logs',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Databricks',
    id: 'Databricks',
    title: 'Databricks',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.TRIAL,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Postman',
    id: 'Postman',
    title: 'Postman',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.TRIAL,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'AWS-EventBridge-for-lambda',
    id: 'AWS-EventBridge-for-lambda',
    title: 'AWS EventBridge for lambda',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Redis',
    id: 'Redis',
    title: 'Redis',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Kafka',
    id: 'Kafka',
    title: 'Kafka',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'Jupyter-notebook',
    id: 'Jupyter-notebook',
    title: 'Jupyter notebook',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
  {
    timeline: [
      {
        moved: 0,
        ringId: ringsENUM.ADOPT,
        date: lastUpdate,
        description: '',
      },
    ],
    url: '#',
    key: 'sbt',
    id: 'sbt',
    title: 'SBT',
    quadrant: quadrantsENUM.TOOLS,
    description: '',
  },
];